import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { WorkflowEditor } from '@/components/settings/workflow-editor';
import { useDisputeTypeById } from '@/hooks/useDisputeTypesData';
import type { WorkflowData } from '@/components/settings/workflow-editor';

const WorkflowEditorPage: React.FC = () => {
  const { disputeTypeId } = useParams<{ disputeTypeId: string }>();
  const navigate = useNavigate();

  const { data: disputeType, isLoading } = useDisputeTypeById(disputeTypeId ?? null);

  const handleSave = (workflow: WorkflowData) => {
    console.log('Saving workflow:', workflow);
  };

  if (isLoading) {
    return (
      <div className="p-6">
        <div className="text-center">
          <p className="text-muted-foreground">Loading dispute type...</p>
        </div>
      </div>
    );
  }

  if (!disputeType) {
    return (
      <div className="p-6">
        <div className="text-center">
          <h2 className="text-2xl font-bold">Dispute Type Not Found</h2>
          <p className="text-muted-foreground mt-2">The requested dispute type could not be found.</p>
        </div>
      </div>
    );
  }

  return <WorkflowEditor disputeType={disputeType} onSave={handleSave} />;
};

export default WorkflowEditorPage;
